import { getCitationOnSelectItem } from '@alpod-ai-writer/plate-plugins/citations';
import { withRef } from '@udecode/cn';
import { PlateElement } from '@udecode/plate/react';
import { filterWords } from '@udecode/plate-combobox';
import { useCallback, useState } from 'react';

import { useCitationList } from '../../hooks/useCitationList.hook';
import { type FilterFn,InlineCombobox, InlineComboboxContent, InlineComboboxEmpty, InlineComboboxGroup, InlineComboboxInput, InlineComboboxItem } from '../common/inlineComboBox.component';

const onSelectItem = getCitationOnSelectItem();

const filterFn: FilterFn = ({ value, group, label, keywords = [] }, search) => {
    if (value === '__new__') {
        return true;
    }

    const uniqueTerms = new Set(
        [value, ...keywords, group, label].filter(Boolean)
    );

    return Array.from(uniqueTerms).some((keyword) =>
        filterWords(keyword!, search)
    );
};

export const CitationInputElement = withRef<typeof PlateElement>(
    ({ className, ...props }, ref) => {
        const { citationList, addCitation } = useCitationList();

        const { children, editor, element } = props;
        const [search, setSearch] = useState('');

        const handleSelectItem = useCallback((key: string, label: string) => {
            if (key === '' && label != '') {
                const { id: key } = addCitation(label);
                onSelectItem(editor, { key, text: key }, search);
            } else {
                onSelectItem(editor, { key, text: key }, search);
            }
        }, [ editor, search ]);

        const isReadOnly = editor.api.isReadOnly();

        return (
            <PlateElement
                ref={ref}
                as="span"
                className={className}
                data-slate-value={element.value}
                {...props}
            >
                {!isReadOnly && (
                    <InlineCombobox
                        value={search}
                        element={element}
                        setValue={setSearch}
                        filter={filterFn}
                        showTrigger={true}
                        trigger="@"
                    >
                        <span className="inline-block rounded-md bg-muted px-1.5 py-0.5 align-baseline text-sm ring-ring focus-within:ring-2 min-w-8 bg-gray-200">
                            <InlineComboboxInput />
                        </span>
                        <InlineComboboxContent
                            className="my-1.5"
                            onMouseDown={e => e.stopPropagation()}
                        >
                            <InlineComboboxEmpty>(nenalezeno)</InlineComboboxEmpty>
                            <InlineComboboxGroup>
                                {citationList.map(([ key, item ]) => (
                                    <InlineComboboxItem
                                        key={key}
                                        value={item.userLabel}
                                        onClick={() => handleSelectItem(key, item.userLabel)}
                                    >
                                        {item.userLabel}
                                    </InlineComboboxItem>
                                ))}
                                {search !== '' && (
                                    <InlineComboboxItem
                                        value={'__new__'}
                                        onClick={() => handleSelectItem('', search)}
                                    >
                                        Vytvořit: {search}
                                    </InlineComboboxItem>
                                )}
                            </InlineComboboxGroup>
                        </InlineComboboxContent>
                    </InlineCombobox>
                )}
                {children}
            </PlateElement>
        );
    }
);
